import { defineStore } from "pinia";
import { ref } from "vue";

export const usePositionsInfoStore = defineStore('positionsInfo', () => {
    const hidePartOfVolume = ref(false);
    const showStartMaxPrice = ref(false);
    const isPositionsRequired = ref(false);

    function setHidePartOfVolume(value) {
        hidePartOfVolume.value = value;
    }

    function setShowStartMaxPrice(value) {
        showStartMaxPrice.value = value;
    }

    function setPositionsRequired(value) {
        isPositionsRequired.value = value;
    }

    function setDefaults() {
        hidePartOfVolume.value = false;
        showStartMaxPrice.value = false;
        isPositionsRequired.value = false;
    }

    return {
        hidePartOfVolume,
        showStartMaxPrice,
        isPositionsRequired,
        setHidePartOfVolume,
        setShowStartMaxPrice,
        setPositionsRequired,
        setDefaults,
    }
});
